/*
  MFO (site fixes I-05, filters printed once). On phones, opens and closes the vertical filter list
  (#FacetsWrapperDesktop, printed once by snippets/facets.liquid) as a drawer. From 750px it's the sidebar and
  these handlers do nothing. Filtering and sorting themselves stay in assets/facets.js.
*/
(function () {
  var OPEN = 'mfo-facets__drawer--open';
  var LOCK = 'mfo-facets-lock';
  var phone = window.matchMedia('(max-width: 749.98px)');
  var lastOpener = null;

  function drawer() {
    return document.getElementById('FacetsWrapperDesktop');
  }

  function setExpanded(value) {
    document.querySelectorAll('[data-mfo-filter-open]').forEach(function (button) {
      button.setAttribute('aria-expanded', value);
    });
  }

  function openDrawer(button) {
    var el = drawer();
    if (!el || !phone.matches) return;
    lastOpener = button;
    el.classList.add(OPEN);
    document.body.classList.add(LOCK);
    setExpanded('true');
    var panel = el.querySelector('.mfo-facets__panel');
    if (panel) {
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('aria-labelledby', 'MfoFacetsTitle');
    }
    var close = el.querySelector('.mfo-facets__close');
    if (close) close.focus();
  }

  function closeDrawer() {
    var el = drawer();
    if (!el || !el.classList.contains(OPEN)) return;
    el.classList.remove(OPEN);
    document.body.classList.remove(LOCK);
    setExpanded('false');
    var panel = el.querySelector('.mfo-facets__panel');
    if (panel) {
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      panel.removeAttribute('aria-labelledby');
    }
    if (lastOpener && lastOpener.isConnected) lastOpener.focus();
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-mfo-filter-open]');
    if (opener) {
      openDrawer(opener);
      return;
    }
    if (event.target.closest('[data-mfo-filter-close]')) {
      closeDrawer();
      return;
    }
    // A tap on the dimmed area beside the panel closes the drawer.
    var el = drawer();
    if (el && el.classList.contains(OPEN) && event.target === el) closeDrawer();
  });

  document.addEventListener('keydown', function (event) {
    var el = drawer();
    if (!el || !el.classList.contains(OPEN)) return;
    if (event.key === 'Escape') {
      closeDrawer();
      return;
    }
    if (event.key !== 'Tab') return;
    // Keep Tab inside the open drawer.
    var items = el.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, summary');
    var visible = Array.prototype.filter.call(items, function (item) {
      return item.offsetParent !== null;
    });
    if (!visible.length) return;
    var first = visible[0];
    var last = visible[visible.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  phone.addEventListener('change', function (mq) {
    if (!mq.matches) closeDrawer();
  });
})();
